import { Routes } from 'react-router-dom';

const Router = () => {
  return (
    <Routes>
    </Routes>
  );
};

export default Router;
